// extracted by mini-css-extract-plugin
export default {"actions":"RoutePayeeDetails_actions__cuVEo","panels":"RoutePayeeDetails_panels__bcj8M","panel":"RoutePayeeDetails_panel__uG5Tt"};